import { flattenDeep, sortBy } from 'lodash-es';
import { TYPE_CHECKBOX, TYPE_NUMBER, TYPE_RADIO, TYPE_SELECT, TYPE_TEXTAREA, TYPE_VIZ, } from '../types/question';
import comuniRaw from './comuni-it-ch.json';
const comuni = sortBy(comuniRaw.filter(({ regione, provincia, stato }, i) => 
// Only Italy/Varese and Svizzera/CantonTicino
(stato === 'IT' && provincia === 'VA') || (stato === 'CH' && regione === 'TI')), 'comune')
    .map(({ comune, provincia, stato }, i) => ({
    name: `${comune} (${provincia === 'VA' ? 'Varese' : provincia}, ${stato})`,
    id: i + 1,
}))
    .concat({ name: 'Altro (specificare)', id: 0 });
export const QUESTIONS_DEF = [
    {
        id: 'start_survey',
        question: '',
        isSkippable: true,
        nextQuestionId: (userAnswersList) => 'municipality_of_residence',
        answers: [],
        type: TYPE_VIZ,
    },
    {
        id: 'municipality_of_residence',
        question: 'In che comune sei residente?',
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'gender',
        previousQuestionId: (userAnswersList) => 'start_survey',
        answers: comuni.map(({ name, id }) => ({
            questionId: 'municipality_of_residence',
            id: `municipality_of_residence_${id}`,
            text: name,
            isOpenAnswer: name === 'Altro (specificare)',
        })),
        type: 'select',
    },
    {
        id: 'gender',
        question: 'Come ti identifichi?',
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'age',
        previousQuestionId: (userAnswersList) => 'municipality_of_residence',
        answers: [
            {
                questionId: 'gender',
                id: 'gender_1',
                text: 'Femmina',
                dataPortrait: {
                    tag: 'circle',
                    fill: '#FF8ED9',
                    radius: 20,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'gender',
                id: 'gender_2',
                text: 'Maschio',
                dataPortrait: {
                    tag: 'circle',
                    fill: '#55D5FE',
                    radius: 20,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'gender',
                id: 'gender_3',
                text: 'Non dichiarato',
                dataPortrait: {
                    tag: 'circle',
                    fill: '#9365F4',
                    radius: 20,
                    reuseElement: 'gender',
                },
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'age',
        question: 'A quale fascia di età appartieni?',
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'start_municipality',
        previousQuestionId: (userAnswersList) => 'gender',
        answers: [
            {
                questionId: 'age',
                id: 'age_1',
                text: 'Meno di 25 anni',
                dataPortrait: {
                    tag: 'circle',
                    radius: 10,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'age',
                id: 'age_2',
                text: 'Tra 25 e 34 anni',
                dataPortrait: {
                    tag: 'circle',
                    radius: 12.5,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'age',
                id: 'age_3',
                text: 'Tra 35 e 44 anni',
                dataPortrait: {
                    tag: 'circle',
                    radius: 15,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'age',
                id: 'age_4',
                text: 'Tra 45 e 65',
                dataPortrait: {
                    tag: 'circle',
                    radius: 17.5,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'age',
                id: 'age_5',
                text: 'Tra 65 e 75',
                dataPortrait: {
                    tag: 'circle',
                    radius: 20,
                    reuseElement: 'gender',
                },
            },
            {
                questionId: 'age',
                id: 'age_6',
                text: 'Più di 75',
                dataPortrait: {
                    tag: 'circle',
                    radius: 22.5,
                    reuseElement: 'gender',
                },
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'start_municipality',
        question: `In un giorno feriale tipico (dal lunedì al venerdì), il tuo viaggio principale, da quale comune ha inizio? `,
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'end_municipality',
        previousQuestionId: (userAnswersList) => 'age',
        answers: comuni.map(({ name, id }) => ({
            questionId: 'start_municipality',
            id: `start_municipality_${id}`,
            text: name,
            isOpenAnswer: name === 'Altro (specificare)',
        })),
        type: TYPE_SELECT,
    },
    {
        id: 'end_municipality',
        question: 'Verso quale comune vai?',
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'travel_reason',
        previousQuestionId: (userAnswersList) => 'start_municipality',
        answers: comuni.map(({ name, id }) => ({
            questionId: 'end_municipality',
            id: `end_municipality_${id}`,
            text: name,
            isOpenAnswer: name === 'Altro (specificare)',
        })),
        type: TYPE_SELECT,
    },
    {
        id: 'travel_reason',
        question: `Qual è il motivo di questo viaggio?`,
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'how_many_travels',
        previousQuestionId: (userAnswersList) => 'end_municipality',
        answers: [
            {
                questionId: 'travel_reason',
                id: 'travel_reason_1',
                text: 'Lavoro',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_2',
                text: 'Studio',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_3',
                text: 'Accompagnamento figli a scuola',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_4',
                text: 'Fruizione di servizi (es: posta, banca, ufficio pubblici, ecc...)',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_5',
                text: 'Acquisti',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_6',
                text: 'Svago',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_7',
                text: 'Sport',
            },
            {
                questionId: 'travel_reason',
                id: 'travel_reason_8',
                text: 'Altro (specificare)',
                isOpenAnswer: true,
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'how_many_travels',
        question: `Quanti viaggi di questo tipo fai mediamente durante la settimana?`,
        subtext: `Esempio: andata e ritorno per 5 giorni di lavoro = 10 spostamenti a settimana`,
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'travel_duration',
        previousQuestionId: (userAnswersList) => 'travel_reason',
        answers: [
            {
                questionId: 'how_many_travels',
                id: 'how_many_travels_1',
                text: 'Meno di 4',
            },
            {
                questionId: 'how_many_travels',
                id: 'how_many_travels_2',
                text: 'Tra 4 e 6',
            },
            {
                questionId: 'how_many_travels',
                id: 'how_many_travels_3',
                text: 'Tra 6 e 10',
            },
            {
                questionId: 'how_many_travels',
                id: 'how_many_travels_4',
                text: 'Più di 10',
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'travel_duration',
        question: `In media, quanto dura questo viaggio?`,
        subtext: 'Considera spostamento porta a porta, con precisione di +- 10 min',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'mean_distance',
        previousQuestionId: (userAnswersList) => 'how_many_travels',
        answers: [
            {
                questionId: 'travel_duration',
                id: 'travel_duration_1',
                text: 'Meno di 10 minuti',
            },
            {
                questionId: 'travel_duration',
                id: 'travel_duration_2',
                text: 'Tra 10 e 20 minuti',
            },
            {
                questionId: 'travel_duration',
                id: 'travel_duration_3',
                text: 'Tra 20 e 30 minuti',
            },
            {
                questionId: 'travel_duration',
                id: 'travel_duration_4',
                text: 'Tra 30 e 45 minuti',
            },
            {
                questionId: 'travel_duration',
                id: 'travel_duration_5',
                text: 'Tra 45 e 60 minuti',
            },
            {
                questionId: 'travel_duration',
                id: 'travel_duration_6',
                text: 'Superiore ad 1 ora',
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'mean_distance',
        question: `Se lo sai, indica i km che percorri per questo viaggio`,
        subtext: `(Considera la distanza porta a porta per un viaggio. Puoi utilizzare un calcolatore d'itinerario come GoogleMaps, Mappy o Viamichelin, arrotondando il valore al chilometro)`,
        maxAnswersNumber: null,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport',
        previousQuestionId: (userAnswersList) => 'travel_duration',
        answers: [
            {
                questionId: 'mean_distance',
                id: 'mean_distance_1',
                text: '',
            },
        ],
        type: TYPE_NUMBER,
    },
    {
        id: 'used_means_of_transport',
        question: 'Quale mezzo usi per fare questo viaggio?',
        subtext: '',
        maxAnswersNumber: 1,
        previousQuestionId: (userAnswersList) => 'mean_distance',
        answers: [
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_car',
                text: 'Automobile come autista',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_car',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#ED3C04',
                    width: 75,
                    height: 75,
                },
                emissions: 0.19,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_car_as_a_passenger',
                text: 'Automobile come passeggero',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_car_as_a_passenger',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#ED3C04',
                    width: 75,
                    height: 75,
                },
                emissions: 0.19,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_park_and_ride',
                text: 'Automobile fino a un parcheggio (Park & Ride) + Trasporti pubblici',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_park_and_ride',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#F17E14',
                    width: 75,
                    height: 75,
                },
                emissions: 0.15,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_carpooling',
                text: "Carpooling (uso dell'automobile privata condivisa tra un gruppo di persone)",
                nextQuestionId: (_userAnswersList) => 'reason_means_of_transport_carpooling',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#F17E14',
                    width: 75,
                    height: 75,
                },
                emissions: 0.1805,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_electric_car',
                text: 'Auto elettrica',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_car',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#EEE50A',
                    width: 75,
                    height: 75,
                },
                emissions: 0.1482,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_bike',
                text: 'Bicicletta',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_bike_or_walk_or_monopattino',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#96E810',
                    width: 75,
                    height: 75,
                },
                emissions: 0.03,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_electric_bike',
                text: 'Bicicletta elettrica',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_bike_or_walk_or_monopattino',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#96E810',
                    width: 75,
                    height: 75,
                },
                emissions: 0.03,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_car_and_bike',
                text: 'Automobile + bicicletta/bicicletta elettrica',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_car_and_bike',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#F1BF0B',
                    width: 75,
                    height: 75,
                },
                emissions: 0.11,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_train',
                text: 'Treno',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_train_or_bus',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#CAE71C',
                    width: 75,
                    height: 75,
                },
                emissions: 0.02,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_bus',
                text: 'Bus',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_train_or_bus',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#CAE71C',
                    width: 75,
                    height: 75,
                },
                emissions: 0.1,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_moto_scooter',
                text: 'Moto/scooter',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_moto_or_scooter',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#ED3C04',
                    width: 75,
                    height: 75,
                },
                emissions: 0.11,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_monopattino',
                text: 'Monopattino',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_bike_or_walk_or_monopattino',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#96E810',
                    width: 75,
                    height: 75,
                },
                emissions: 0,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_walk',
                text: 'A piedi',
                nextQuestionId: (userAnswersList) => 'reason_means_of_transport_bike_or_walk_or_monopattino',
                dataPortrait: {
                    tag: 'rect',
                    fill: '#96E810',
                    width: 75,
                    height: 75,
                },
                emissions: 0,
            },
            {
                questionId: 'used_means_of_transport',
                id: 'used_means_of_transport_others',
                text: 'Altro (specificare)',
                nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
                isOpenAnswer: true,
                dataPortrait: {
                    tag: 'rect',
                    fill: '#F9F01C',
                    width: 75,
                    height: 75,
                },
                emissions: 0.095,
            },
        ],
        type: TYPE_RADIO,
    },
    //////////////////////
    {
        id: 'reason_means_of_transport_car',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli l'auto?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_car',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché mi piace guidare
      Perché è la soluzione che ritengo più rapida
      Perché è la soluzione che ritengo più economica
      Perché ho disponibilità di sosta gratuita presso la destinazione
      Per vincoli di orari
      Perché il mio punto di partenza e/o di arrivo è mal servito dal trasporto pubblico
      Perché il mio punto di partenza e/o di arrivo è mal servito da infrastrutture ciclabili
      Perché posso fare deviazioni all’andata e/o al ritorno
      Per poter rientrare a casa per pranzo con poco tempo a disposizione
      Perché mi serve l’auto per spostamenti professionali durante la giornata
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_car',
            id: `reason_means_of_transport_car_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_car_as_a_passenger',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli l'auto come passeggero?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_car_as_a_passenger',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché non ho la patente
      Perché non mi piace guidare
      Perché è la soluzione che ritengo più economica
      Perché vi è disponibilità di sosta gratuita presso la destinazione
      Per vincoli orari
      Perché il mio punto di partenza e/o di arrivo è mal servito dal trasporto pubblico
      Perché il mio punto di partenza e/o di arrivo è mal servito da infrastrutture ciclabili
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_car_as_a_passenger',
            id: `reason_means_of_transport_car_as_a_passenger_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_park_and_ride',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli il Park & Ride e poi i trasporti pubblici?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_park_and_ride',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché è la soluzione che ritengo più economica
      Perché non vi è disponibilità di sosta gratuita presso la destinazione
      Per vincoli orari
      Perché la destinazione è ben servita dal trasporto pubblico
      Per vincolo - origine/destinazione mal servita da infrastrutture ciclabili
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_park_and_ride',
            id: `reason_means_of_transport_park_and_ride_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_carpooling',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli il carpooling?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_carpooling',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché mi fa piacere condividere il tempo del tragitto con altre persone
      Perché mi consente di conoscere altre persone
      Perché è la soluzione che ritengo più economica
      Perché vi è disponibilità di sosta gratuita presso la destinazione
      Per vincoli orari
      Perché il mio punto di partenza e/o di arrivo è mal servito dal trasporto pubblico
      Perché il mio punto di partenza e/o di arrivo è mal servito da infrastrutture ciclabili
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_carpooling',
            id: `reason_means_of_transport_carpooling_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_bike_or_walk_or_monopattino',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli di spostarti a piedi, in bicicletta o in monopattino?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché è la soluzione che ritengo più sostenibile
      Perché è la soluzione che ritengo più economica
      Perché mi consente di ammirare il paesaggio che mi circonda durante il tragitto
      Perché mi consente di fare attività sportiva mentre mi sposto (a beneficio per la mia salute)
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_bike_or_walk_or_monopattino',
            id: `reason_means_of_transport_bike_or_walk_or_monopattino_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_car_and_bike',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli l’auto + la bicicletta?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_car_and_bike',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché mi piace guidare
      Perché è la soluzione che ritengo più economica
      Perché ho disponibilità di sosta gratuita presso la destinazione
      Per vincoli orari
      Perché il mio punto di partenza e/o di arrivo è mal servito dal trasporto pubblico
      Perché il mio punto di partenza e/o di arrivo è mal servito da infrastrutture ciclabili
      Perché posso fare deviazioni all’andata e/o al ritorno
      Per poter rientrare a casa per pranzo con poco tempo a disposizione
      Perché mi serve l’auto per spostamenti professionali durante la giornata
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_car_and_bike',
            id: `reason_means_of_transport_car_and_bike_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_train_or_bus',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli il treno o il bus?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Perché è la soluzione che ritengo più economica
      Perché è la soluzione che ritengo più sostenibile
      Per abitudine
      Perché è la soluzione che ritengo più rapida
      Perché mi consente di ammirare il paesaggio che mi circonda durante il tragitto
      Perché mi consente di socializzare con altre persone durante il tragitto
      Perché mi consente di ottimizzare il tempo dello spostamento (per leggere, ascoltare musica, dormire, ecc..)
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_train_or_bus',
            id: `reason_means_of_transport_train_or_bus_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'reason_means_of_transport_moto_or_scooter',
        question: `Sempre considerando il tuo viaggio principale, per quale di questi motivi scegli la moto o lo scooter?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'willing_to_avoid_moto_or_scooter',
        previousQuestionId: (userAnswersList) => 'used_means_of_transport',
        answers: `
      Per abitudine
      Perché mi piace guidare
      Perché è la soluzione che ritengo più rapida
      Perché è la soluzione che ritengo più economica
      Perché ho disponibilità di sosta gratuita presso la destinazione
      Per vincoli di orari
      Perché il mio punto di partenza e/o di arrivo è mal servito dal trasporto pubblico
      Perché il mio punto di partenza e/o di arrivo è mal servito da infrastrutture ciclabili
      Perché posso fare deviazioni all’andata e/o al ritorno
      Per poter rientrare a casa per pranzo con poco tempo a disposizione
      Perché mi serve l’auto per spostamenti professionali durante la giornata
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'reason_means_of_transport_moto_or_scooter',
            id: `reason_means_of_transport_moto_or_scooter_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    ////////////////////////
    {
        id: 'willing_to_avoid_car',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare all’auto?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_car',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_car',
            id: `willing_to_avoid_car_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'willing_to_avoid_car_as_a_passenger',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare all’auto come passeggero?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_car_as_a_passenger',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_car_as_a_passenger',
            id: `willing_to_avoid_car_as_a_passenger_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'willing_to_avoid_park_and_ride',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare il Park & Ride e poi i trasporti pubblici?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_park_and_ride',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_park_and_ride',
            id: `willing_to_avoid_park_and_ride_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'willing_to_avoid_carpooling',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare al carpooling?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_carpooling',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_carpooling',
            id: `willing_to_avoid_carpooling_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'willing_to_avoid_car_and_bike',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare all’auto + la bicicletta?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_car_and_bike',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_car_and_bike',
            id: `willing_to_avoid_car_and_bike_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    {
        id: 'willing_to_avoid_moto_or_scooter',
        question: `Sempre considerando il tuo viaggio principale, quale di questi motivi ti spingerebbe a rinunciare alla moto o allo scooter?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        previousQuestionId: (userAnswersList) => 'reason_means_of_transport_moto_or_scooter',
        answers: `
      Assenza di parcheggi presso la destinazione
      Parcheggi solo a pagamento presso la destinazione
      Zone ad accesso controllato (a pagamento, limitato a classi di auto, ecc)
      Incentivi economici a favore di modi alternativi (premi, bonus, ecc...)
      Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali
      Altro (specificare)
    `
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((text, i) => ({
            questionId: 'willing_to_avoid_moto_or_scooter',
            id: `willing_to_avoid_moto_or_scooter_${i}`,
            text,
            isOpenAnswer: text === 'Altro (specificare)',
        })),
        type: TYPE_CHECKBOX,
    },
    ////////////////////////
    {
        id: 'used_means_of_transport_weekend',
        question: `Il sabato e la domenica (o nei giorni festivi), con quale mezzo ti sposti prevalentemente?`,
        subtext: '',
        maxAnswersNumber: 1,
        nextQuestionId: (userAnswersList) => 'MID_VIZ',
        previousQuestionId: (userAnswersList) => {
            // const flatUserAnswerList = flattenDeep(userAnswersList)
            // const userAnswer = flatUserAnswerList.find(
            //   (answer) => answer.questionId === 'used_means_of_transport'
            // )
            // TODO: this incorrectly jumps back one/two questions to avoid difficult logic
            return 'used_means_of_transport';
        },
        answers: [
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_1',
                text: 'Automobile come autista',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_2',
                text: 'Automobile come passeggero',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_3',
                text: 'Automobile fino a un parcheggio (Park & Ride) + trasporti pubblici',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_4',
                text: 'Carpooling',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_5',
                text: 'Auto elettrica',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_6',
                text: 'Bicicletta',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_7',
                text: 'Bicicletta elettrica',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_8',
                text: 'Automobile + bicicletta/bicicletta elettrica',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_9',
                text: 'Treno',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_10',
                text: 'Bus',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_11',
                text: 'Moto/scooter',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_12',
                text: 'A piedi',
            },
            {
                questionId: 'used_means_of_transport_weekend',
                id: 'used_means_of_transport_weekend_13',
                text: 'Altro (specificare)',
                isOpenAnswer: true,
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'MID_VIZ',
        question: `Per ogni spostamento, in base alla lunghezza dello spostamento e il mezzo utilizzato, le tue emissioni sono:`,
        subtext: '',
        maxAnswersNumber: null,
        isSkippable: true,
        nextQuestionId: (userAnswersList) => {
            const flatUserAnswerList = flattenDeep(userAnswersList);
            const userAnswer = flatUserAnswerList.find((answer) => answer.questionId === 'used_means_of_transport');
            if ([
                'used_means_of_transport_car',
                'used_means_of_transport_car_as_a_passenger',
                'used_means_of_transport_park_and_ride',
                'used_means_of_transport_carpooling',
                'used_means_of_transport_electric_car',
            ].includes(userAnswer.id)) {
                return 'willing_to_use_alternative_means_of_transport';
            }
            return 'suggestions';
        },
        previousQuestionId: (userAnswersList) => 'used_means_of_transport_weekend',
        answers: [
            {
                questionId: 'MID_VIZ',
                id: 'MID_VIZ_1',
                text: '',
                dataPortrait: {
                    tag: 'texture',
                },
            },
        ],
        type: TYPE_VIZ,
    },
    {
        id: 'willing_to_use_alternative_means_of_transport',
        question: `Saresti pronto/a ad utilizzare modi alternativi all\'automobile per il tuo spostamento?`,
        subtext: '',
        maxAnswersNumber: 1,
        previousQuestionId: (userAnswersList) => 'MID_VIZ',
        answers: [
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_1',
                text: 'No',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_public_transport',
                dataPortrait: {
                    tag: 'path',
                    fill: '#000',
                    d: 'M0 34.0002H0.656681C4.89862 33.6294 9.64816 26.3028 12.5 22.5003C27 -0.999807 33.2994 0.18824 38 0.000244141C50 8.20933e-05 58 15 63 22.0002C70.5 33 73.3333 33.6669 75 34.0002H0.656681C0.436305 34.0195 0.217299 34.02 0 34.0002Z',
                    height: 34,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_2',
                text: 'Si, potrei prevedere di usare il trasporto pubblico',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_public_transport',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 13.994H0.656686C4.89862 13.8414 9.64816 10.8258 12.5 9.26075C27 -0.411609 33.2994 0.0773768 38 0C50 -6.66967e-05 58 6.17371 63 9.05493C70.5 13.5823 73.3333 13.8568 75 13.994H0.656686C0.436308 14.0019 0.2173 14.0021 0 13.994Z',
                    height: 14,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_3',
                text: 'Si, potrei prevedere di fare un tratto del mio viaggio in trasporto pubblico usando un park & ride sul percorso',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_public_transport',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 13.994H0.656686C4.89862 13.8414 9.64816 10.8258 12.5 9.26075C27 -0.411609 33.2994 0.0773768 38 0C50 -6.66967e-05 58 6.17371 63 9.05493C70.5 13.5823 73.3333 13.8568 75 13.994H0.656686C0.436308 14.0019 0.2173 14.0021 0 13.994Z',
                    height: 14,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_4',
                text: 'Si, potrei prevedere di usare la bicicletta e/o la bicicletta elettrica',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_bike',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 23.9897H0.656677C4.89861 23.7281 9.64816 18.5585 12.5 15.8756C27 -0.705615 33.2994 0.132646 38 0C50 -0.000114337 58 10.5835 63 15.5227C70.5 23.2839 73.3333 23.7545 75 23.9897H0.656677C0.436302 24.0033 0.217297 24.0036 0 23.9897Z',
                    height: 24,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_5',
                text: 'Si, potrei prevedere di andare a piedi',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_walk',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 23.9897H0.656677C4.89861 23.7281 9.64816 18.5585 12.5 15.8756C27 -0.705615 33.2994 0.132646 38 0C50 -0.000114337 58 10.5835 63 15.5227C70.5 23.2839 73.3333 23.7545 75 23.9897H0.656677C0.436302 24.0033 0.217297 24.0036 0 23.9897Z',
                    height: 24,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_6',
                text: 'Si, potrei prevedere di fare carpooling',
                nextQuestionId: (userAnswersList) => 'conditions_necessary_for_carpooling',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 13.994H0.656686C4.89862 13.8414 9.64816 10.8258 12.5 9.26075C27 -0.411609 33.2994 0.0773768 38 0C50 -6.66967e-05 58 6.17371 63 9.05493C70.5 13.5823 73.3333 13.8568 75 13.994H0.656686C0.436308 14.0019 0.2173 14.0021 0 13.994Z',
                    height: 14,
                },
            },
            {
                questionId: 'willing_to_use_alternative_means_of_transport',
                id: 'willing_to_use_alternative_means_of_transport_7',
                text: 'Si, potrei prevedere altri modi alternativi (specificare)',
                nextQuestionId: (userAnswersList) => 'suggestions',
                dataPortrait: {
                    tag: 'path',
                    fill: '#fff',
                    d: 'M0 23.9897H0.656677C4.89861 23.7281 9.64816 18.5585 12.5 15.8756C27 -0.705615 33.2994 0.132646 38 0C50 -0.000114337 58 10.5835 63 15.5227C70.5 23.2839 73.3333 23.7545 75 23.9897H0.656677C0.436302 24.0033 0.217297 24.0036 0 23.9897Z',
                    height: 24,
                },
                isOpenAnswer: true,
            },
        ],
        type: TYPE_RADIO,
    },
    {
        id: 'conditions_necessary_for_public_transport',
        question: `Quali sarebbero le condizioni necessarie per l’utilizzo del trasporto pubblico?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'suggestions',
        previousQuestionId: (userAnswersList) => 'willing_to_use_alternative_means_of_transport',
        answers: [
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_1',
                text: 'Un tragitto meno complicato (razionalizzazione dei percorsi delle linee)',
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_2',
                text: `Un servizio di trasporto pubblico con tempi di viaggio più brevi`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_3',
                text: `Un migliore servizio offerto in prossimità del mio domicilio (fermata più vicina, pensilina coperta, etc.)`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_4',
                text: `Maggiore flessibilità del servizio e possibilità di interscambio tra mezzi pubblici`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_5',
                text: `Un servizio di trasporto pubblico più frequente e con orari più adeguati`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_6',
                text: `Coincidenze più efficaci tra bus e treno presso la stazione`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_7',
                text: `Un miglioramento dei comfort del trasporto pubblico`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_8',
                text: `Un incentivo finanziario all'utilizzo del trasporto pubblico`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_9',
                text: `Un mezzo aziendale di trasporto a disposizione per coprire gli spostamenti professionali`,
            },
            {
                questionId: 'conditions_necessary_for_public_transport',
                id: 'conditions_necessary_for_public_transport_10',
                text: `Altro (specificare)`,
                isOpenAnswer: true,
            },
        ],
        type: TYPE_CHECKBOX,
    },
    {
        id: 'conditions_necessary_for_bike',
        question: `Quali sarebbero le condizioni necessarie per l'utilizzo della bici o bicicletta elettrica?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'suggestions',
        previousQuestionId: (userAnswersList) => 'willing_to_use_alternative_means_of_transport',
        answers: [
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_1',
                text: 'Percorsi ciclabili più sicuri',
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_2',
                text: `Marciapiedi e attraversamenti pedonali continui e maggiormente sicuri`,
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_3',
                text: `Possibilità di parcheggiare la bicicletta in sicurezza (rastrelliere coperte, bike box, velostazioni, etc.)`,
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_4',
                text: `Maggiore comfort a destinazione (spogliatoi, docce, armadietti)`,
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_5',
                text: `Un incentivo finanziario all'utilizzo della bicicletta/bicicletta elettrica`,
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_6',
                text: `Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali`,
            },
            {
                questionId: 'conditions_necessary_for_bike',
                id: 'conditions_necessary_for_bike_7',
                text: `Altro (specificare)`,
                isOpenAnswer: true,
            },
        ],
        type: TYPE_CHECKBOX,
    },
    {
        id: 'conditions_necessary_for_walk',
        question: `Quali sarebbero per te le condizioni necessarie per spostarti a piedi?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'suggestions',
        previousQuestionId: (userAnswersList) => 'willing_to_use_alternative_means_of_transport',
        answers: [
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_1',
                text: `Un miglioramento della sicurezza sul mio tragitto (percorsi pedonali continui e sicuri)`,
            },
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_2',
                text: `Marciapiedi e attraversamenti pedonali continui e maggiormente sicuri`,
            },
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_3',
                text: `Maggiore comfort a destinazione (spogliatoi, docce, armadietti)`,
            },
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_4',
                text: `Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali`,
            },
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_5',
                text: `Conoscere meglio gli effetti positivi su inquinamento e cambiamenti climatici`,
            },
            {
                questionId: 'conditions_necessary_for_walk',
                id: 'conditions_necessary_for_walk_6',
                text: `Altro (specificare)`,
                isOpenAnswer: true,
            },
        ],
        type: TYPE_CHECKBOX,
    },
    {
        id: 'conditions_necessary_for_carpooling',
        question: `Quali sarebbero le condizioni necessarie per l'utilizzo del carpooling?`,
        subtext: 'Max 3 risposte',
        maxAnswersNumber: 3,
        nextQuestionId: (userAnswersList) => 'suggestions',
        previousQuestionId: (userAnswersList) => 'willing_to_use_alternative_means_of_transport',
        answers: [
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_1',
                text: `Una sosta privilegiata alla destinazione (posti migliori riservati a chi effettua carpooling)`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_2',
                text: `Incentivi finanziari alla pratica del carpooling`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_3',
                text: `Una piattaforma di scambio aziendale/scolastica per trovare partner di viaggio`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_4',
                text: `Punti di incontro chiaramente identificabili e dislocati sul territorio`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_5',
                text: `Soluzioni ad hoc per il ritorno a casa in caso di emergenza (malattia, problema con i bambini, ecc.)`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_6',
                text: `Un mezzo di trasporto adeguato a disposizione per i miei spostamenti professionali`,
            },
            {
                questionId: 'conditions_necessary_for_carpooling',
                id: 'conditions_necessary_for_carpooling_7',
                text: `Altro (specificare)`,
                isOpenAnswer: true,
            },
        ],
        type: TYPE_CHECKBOX,
    },
    {
        id: 'suggestions',
        question: `Commenti o suggerimenti per l'adozione di misure che faciliterebbero l'esperienza negli spostamenti sistematici e occasionali`,
        subtext: 'O vai avanti al risultato',
        maxAnswersNumber: null,
        nextQuestionId: (userAnswersList) => 'end_of_survey',
        previousQuestionId: (userAnswersList) => {
            // TODO: this incorrectly jumps back one/two questions to avoid difficult logic
            return 'willing_to_use_alternative_means_of_transport';
        },
        answers: [
            {
                questionId: 'suggestions',
                id: 'suggestions_1',
                text: '',
            },
        ],
        type: TYPE_TEXTAREA,
        isSkippable: true,
    },
];
